import React from 'react'

const ProgressBar = ({uploadpercents, uploadError}) => {    
    console.log(uploadpercents);
    return (
        <div className="myProgress">
            <div className="myBar" style={{background:uploadError, width:uploadpercents+'%'}}>{uploadpercents} %</div>
        </div>
    )
}

export default ProgressBar
